export const removeEmoji = (str: string) => {
  return str.replace(
    /([\u2700-\u27BF]|[\uE000-\uF8FF]|\u24C2|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|\uD83E[\uDD00-\uDFFF])/g,
    ""
  );
};

export const isValidEmail = (value: string): boolean => {
  if (value.trim() === "") return false;
  if (!value.includes("@")) return false;
  const validDomains = [".com", ".in", ".co"];
  return validDomains.some((domain) => value.endsWith(domain));
};